<template>
  <div>
    <div v-if="loading">Cargando...</div>
    <div v-else>
      <table class="uk-table uk-table-divider uk-table-justify uk-text-left">
        <thead>
          <tr>
            <th>Tarea</th>
            <th style="width: 100px">Fecha</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(log, key, index) in sortedItemsByDate"
            :key="index"
            :id="key"
          >
            <td :id="log.key">
              <h4 class="uk-margin-remove">{{ log.logDescription }}</h4>
              <span
                class="
                  uk-border-rounded
                  uk-label
                  uk-background-secondary
                  uk-text-small
                  uk-margin-small-right
                "
              >
                {{ log.client }}
              </span>
              <span
                class="
                  uk-margin-small-right
                  uk-border-rounded
                  uk-label
                  uk-background-primary
                "
                >{{ log.hours + "." + log.minutes }} hrs</span
              >
            </td>
            <td>{{ log.date }}</td>
            <td>
              <a @click="deleteLogItem(log.key)">
                <span
                  class="uk-icon-button uk-margin-small-right uk-icon uk-alert-danger"
                  uk-icon="trash"
                ></span>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import {
  getDatabase,
  ref,
  onValue,
  query,
  orderByChild,
  remove,
} from "firebase/database";
import { getAuth } from "firebase/auth";

export default {
  name: "Logs",

  data() {
    return {
      loading: false,
      logs: {},
    };
  },
  methods: {
    async getLogs() {
      this.loading = true;
      const db = getDatabase();
      const logsRef = query(ref(db, "logs"));

      onValue(logsRef, (snapshot) => {
        const data = snapshot.val();
        if (snapshot.exists()) {
          this.logs = data;
          this.loading = false;
        } else {
          this.logs = {};
          this.loading = false;
        }
      });
    },
    deleteLogItem(key) {
      UIkit.modal.confirm("Seguro que quieres borrar la entrada?").then(
        function () {
          const db = getDatabase();
          remove(ref(db, "logs/" + key)).then(() => {
            console.log("Log deleted");
          });
        },
        function () {
          console.log("Rejected.");
        }
      );
    },
  },
  computed: {
    filteredLogs() {
      const auth = getAuth();
      const newLogs = this.logs;

      const userLogs = Object.keys(newLogs).map((key) => {
        return {
          ...newLogs[key],
          key,
        };
      });

      const filteredLogs = userLogs.filter((log) => {
        return log.uid === auth.currentUser.uid;
      });

      return filteredLogs;
    },
    sortedItemsByDate: function () {
      return this.filteredLogs.sort(
        (a, b) => new Date(b.date) - new Date(a.date)
      );
    },
  },
  created() {
    this.getLogs();
  },
};
</script>

<style></style>
